module.exports = __webpack_public_path__ + "static/media/pinkTick.77397b54.png";